import DashboardInvestor from "./routes/dashboard.factoring";

export default [
  {
    path: "",
    name: "dashboard-root",
    beforeEnter: (to: any, from: any, next: any) => {
      next({
        name: "dashboard-stats"
      });
    }
  },
  ...DashboardInvestor.map((route: any) => {
    route.path = `${route.path}`;
    route.name = `${route.name}`;
    return route;
  }),
];
